import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import Button from './Button';
import ButtonSecondary from './ButtonSecondary';

export default function IncompleteServicesDialog({ 
    open, 
    onClose, 
    incompleteCount, 
    onComplete, 
    onRemove 
}) {
    // #region agent log
    fetch('http://127.0.0.1:7243/ingest/0286a46c-a724-49ff-9d50-177521f90ff5',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'IncompleteServicesDialog.js:11',message:'IncompleteServicesDialog render',data:{open,incompleteCount},timestamp:Date.now(),sessionId:'debug-session',runId:'run4',hypothesisId:'F'})}).catch(()=>{});
    // #endregion
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="incomplete-services-dialog-title"
                aria-describedby="incomplete-services-dialog-description"
            >
                <DialogTitle 
                    id="incomplete-services-dialog-title"
                    style={{ 
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 600,
                        fontSize: '18px'
                    }}
                >
                    Incomplete Services Found
                </DialogTitle>
                <DialogContent>
                    <DialogContentText 
                        id="incomplete-services-dialog-description"
                        style={{ 
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: '14px',
                            color: '#3E3E4A'
                        }}
                    >
                        You have {incompleteCount} incomplete {incompleteCount === 1 ? 'service' : 'services'}. 
                        Services need a service name to be saved. Would you like to complete them now or remove them?
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ padding: '16px 24px', display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                    <ButtonSecondary 
                        onClick={onRemove}
                    >
                        Remove Incomplete Services
                    </ButtonSecondary>
                    <Button 
                        onClick={onComplete}
                    >
                        Complete Them
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
